import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import { modulo10 } from "../../../routes/Module10";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo10/interpelacion.png";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo10/Actividad 6.mp3";

const Actividad6 = () => {
  const infoUnidad = modulo10.content[0];
  const infoAct = modulo10.content[0].activities[5];
  const crumbs = [
    {
      title: modulo10.title,
      url: "/" + modulo10.url,
    },
    {
      title:
        modulo10.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo10.content[0].activities[6].name}`,
    linkNext: `${modulo10.url}/${modulo10.content[0].path}/${modulo10.content[0].activities[6].path}`,
    titlePrev: `${modulo10.content[0].activities[4].name}`,
    linkPrev: `${modulo10.url}/${modulo10.content[0].path}/${modulo10.content[0].activities[4].path}`,
  };
  const metadata = {
    color: modulo10.color,
    title: `${modulo10.title} - ${infoAct.name}`,
    name: modulo10.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo10.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <div className="row">
        <div className="col-md-10 col-12 p-0">
          <ul className="mb-5">
            <li>
              El Congreso puede pedir a los ministros y ministras que vayan a
              explicar cómo están haciendo su trabajo. En algunos casos, después
              de escuchar al ministro, los y las congresistas debaten para ver
              si le dan su apoyo.
            </li>
            <li>Observa la siguiente viñeta.</li>
          </ul>
        </div>
      </div>
      <img src={Imagen1} alt="Votación" className="img-fluid mb-5" />
      <ul>
        <li>
          Conversa sobre estas preguntas con un compañero, compañera o familiar.
        </li>
      </ul>
      <div className="row">
        <div className="col-lg-10 col-12">
          <p>¿Cuál es el problema?</p>
          <textarea rows={3} className="form-control mb-3" />
          <p>¿Por qué ha ido la ministra al Congreso?</p>
          <textarea rows={3} className="form-control mb-3" />

          <p>
            Si ustedes fueran congresistas, ¿votarían a favor o en contra de que
            la ministra se quede en su cargo? Expliquen las razones de su
            decisión.
          </p>
          <textarea rows={3} className="form-control mb-3" />
        </div>
      </div>

      <GuiaDocente>
        <p>
          Luego de leer las indicaciones y la viñeta, comente que es deber del
          Congreso vigilar a los ministros. Dialogue sobre las preguntas. Pida
          que expongan sus ideas y las justifiquen.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad6;
